<script>import { getCtx, getAttrs } from "../ctx.js";
export let placeholder = "";
export let asChild = false;
const {
  states: { selectedLabel }
} = getCtx();
const attrs = getAttrs("value");
$:
  label = $selectedLabel;
</script>

{#if asChild}
	<slot {label} {attrs} />
{:else}
	<span {...$$restProps} {...attrs}>
		{label ? label : placeholder}
	</span>
{/if}
